<template>
  <div class="inner-wrapper">
    <div class="inner-container main is-mob">
      <!-- 이미지 -->
      <div id="main-section" class="content-header has-bg">
        <video ref="mainVideo" autoplay muted loop playsinline>
          <source src="@/assets/images/portal/bg/main/bg_main_new.mp4" type="video/mp4"/>
        </video>
        <div class="content-header-inner">
          <!-- 팝업존 -->
          <div v-if="$validate.isNotEmpty( popupZoneList )">
            <!-- 팝업존 열기 버튼 -->
            <el-button class="popup-btn is-active" @click="openPopup">
              <img src="@/assets/images/portal/icon/main/icon_notification.svg" alt="팝업 열기">
              <span class="btn-text">POPUP</span>
              <strong class="badge">{{ popupZoneList.length }}</strong>
            </el-button>

            <!-- 팝업존 -->
            <the-popup-zone
              v-show="isPopupZoneVisible"
              :visible="isPopupZoneVisible"
              :popup-list="popupZoneList"
              :is-view-all="isViewAllPopupZone"
              is-parent-scroll-control
              @onClose="closePopupZone"
              @onClickViewAll="openViewAllPopupZone"
              @onCloseViewAll="closeViewAllPopupZone( 'popupZone' )"
            />
            <!-- 레이어 팝업 : 웹에서만 노출됩니다. -->
            <the-layer-popup
              v-show="isLayerPopupVisible"
              :visible="isLayerPopupVisible"
              :popup-list="layerPopupList"
              ignore-cookie
              is-parent-scroll-control
              @close="closeViewAllPopupZone( 'layerPopup' )"
            />
          </div>
          <!-- 동영상 일시정지/재생 버튼 -->
          <el-button class="video-btn" @click="toggleVideo">
            <img v-if="isVideoPlaying" src="@/assets/images/portal/icon/main/icon_pause.svg" alt="일시정지">
            <img v-else src="@/assets/images/portal/icon/main/icon_play.svg" alt="재생">
          </el-button>
        </div>
        <div class="inner">
          <!-- lms 퀵 메뉴 -->
          <the-quick-lms-menu/>
        </div>
      </div>
      <!-- body -->
      <div class="content-body">
        <!-- 바로가기 서비스 -->
        <div id="service-section" class="main-content quick">
          <div class="inner-content">
            <div class="detail-content has-bg">
              <!-- 원주 사이트 퀵 메뉴 -->
              <the-quick-wonju-menu/>

              <!-- 원주 사이트 모바일 퀵 메뉴 -->
              <the-mob-quick-wonju-menu/>
            </div>
          </div>
        </div>
        <!-- board content -->
        <div id="notice-section" class="main-content board">
          <div class="inner-content">
            <div class="flex-area pb0">
              <div class="flex-col informant">
                <!-- 정보원 소식 -->
                <the-main-notice-list/>
              </div>
              <div class="list-container">
                <!-- 전자책 -->
                <div class="flex-col ebook">
                  <the-portlet-ebook-list/>
                </div>
                <!-- 행사일정 -->
                <div class="flex-col schedule">
                  <the-main-schedule-list/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- content -->
        <div id="link-section" class="main-content content">
          <div class="inner-content">
            <div class="flex-area pb0">
              <!-- 체험 프로그램 -->
              <div class="flex-col experience">
                <the-portlet-program-list/>
              </div>
              <!-- 유튜브 -->
              <div class="flex-col youtube">
                <the-portlet-youtube-list/>
              </div>
            </div>
          </div>
        </div>
        <!-- content -->
        <div class="main-content link-list">
          <div class="inner-content">
            <the-main-link-list/>
          </div>
        </div>
      </div>
    </div>
    <!-- 스크롤 버튼 -->
    <el-button
      class="scroll-button"
      :class="{ 'is-reversed' : isScrollButtonReversed }"
      @click="handleScrollButtonClick"
    >
      <span class="visually-hidden" v-text="isScrollButtonReversed ? '스크롤 위로 이동' : '스크롤 아래로 이동'"/>
      <img class="mouse" src="@/assets/images/portal/icon/main/icon_mouse.svg" alt="마우스 아이콘" />
      <img
        v-if="!isScrollButtonReversed"
        class="arrow-down"
        src="@/assets/images/portal/icon/main/icon_down.svg"
        alt="스크롤 아래로 이동 화살표"
      />
      <img
        v-else
        class="arrow-up"
        src="@/assets/images/portal/icon/main/icon_up.svg"
        alt="스크롤 위로 이동 화살표"
      />
    </el-button>
    <!-- 영역 이동 내비게이션 -->
    <nav
      ref="scrollSpyNav"
      class="scroll-spy-nav"
      :class="{ 'is-fixed': isScrollSpyFixed, 'change-color': isScrollSpyChangeColor }"
    >
      <ul>
        <li
          v-for="( section, index ) in sectionList"
          :key="index"
          :class="{ 'is-active' : activeSection === section.target }"
          v-text="section.name"
          @click="scrollToSection( section.target )"
        />
      </ul>
    </nav>
    <!-- 팝업 (레이어) -->
    <the-layer-popup
      v-if="$validate.isNotEmpty( layerPopupList )"
      :popup-list="layerPopupList"
      :visible="true"
    />
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import Cookie from "js-cookie";

import TheMainSearch from "~/components/portal/user/main/TheMainSearch";
import TheQuickLmsMenu from "~/components/portal/user/main/TheQuickLmsMenu";
import TheMobQuickLmsMenu from "~/components/portal/user/mobile/main/TheMobQuickLmsMenu";
import TheQuickWonjuMenu from "~/components/portal/user/main/TheQuickWonjuMenu";
import TheMobQuickWonjuMenu from "~/components/portal/user/mobile/main/TheMobQuickWonjuMenu";
import TheMainNoticeList from "~/components/portal/user/main/TheMainNoticeList";
import TheMainScheduleList from "~/components/portal/user/main/TheMainScheduleList";

import TheLayerPopup from "~/components/common/popup/TheLayerPopup.vue";
import ThePopupZone from "~/components/common/popup/ThePopupZone.vue";

// portlnet
import ThePortletYoutubeList from "~/components/portal/user/portlet/ThePortletYoutubeList";
import ThePortletEbookList from "~/components/portal/user/portlet/ThePortletEbookList";
import ThePortletProgramList from "~/components/portal/user/portlet/ThePortletProgramList";
import TheMainLinkList from "~/components/portal/user/main/TheMainLinkList";
import froalaEditorUtil from "~/utils/site/portal/froala_editor_util";
import portalApiUrl from '~/constant/site/portal/portalApiUrl';

export default {
  layout: 'userLayout',
  components: {
    TheMainLinkList,
    TheMobQuickLmsMenu,
    TheMainScheduleList,
    TheMainNoticeList,
    TheQuickWonjuMenu,
    TheMobQuickWonjuMenu,
    TheQuickLmsMenu,
    TheMainSearch,
    ThePortletEbookList,
    ThePortletYoutubeList,
    ThePortletProgramList,
    TheLayerPopup,
    ThePopupZone,
  },
  data() {
    return {

      // 모바일인지 여부
      isMobileMode : this.$validate.isMobile(),

      isVideoPlaying: true, // 영상 재생

      // popup
      layerPopupList: [],
      popupZoneList: [],

      // isActivePopupBtn : false, // 팝업존 열기/닫기 버튼 ( 모바일에서는 항상 닫은 상태여야합니다. )
      isPopupZoneVisible: false, // 팝업존 노출여부
      isLayerPopupVisible : false, // 레이어 팝업 (쿠키상관없이 전부) 노출여부 ( 모바일에서는 아예 노출되지 않습니다. )
      isViewAllPopupZone : false, // 팝업존 전체보기

      isScrollButtonReversed: false, // 스크롤 버튼

      // 영역 이동 내비게이션
      sectionList: [
        { name: "첫화면", target: "main-section" },
        { name: "바로가기", target: "service-section" },
        { name: "알림소식", target: "notice-section" },
        { name: "체험센터", target: "link-section" },
      ],
      activeSection: "main-section",
      isScrolling: false,
      isScrollSpyFixed: false,
      isScrollSpyChangeColor: false,
    }
  },

  computed: {
    ...mapGetters( {
      loginUser: "common/login/loginUserInfo",
    } ),
  },

  async created() {
    await this.saveAuditVisit();
  },

  mounted() {
    // 통합회원 처리하지않고 강제로넘어왔을시 로그아웃처리.
    this.intergratedUserCheck();

    window.addEventListener( "scroll", this.checkScrollButtonDirection );
    window.addEventListener( "scroll", this.updateScrollSpyState);

    this.updateScrollSpyState();
  },

  beforeDestroy() {
    window.addEventListener( "scroll", this.checkScrollButtonDirection );
    window.addEventListener( "scroll", this.updateScrollSpyState );
  },

  async fetch() {

    // 팝업존 관련 데이터 초기화
    this.initPopupData();
    await this.listPopup();
  },

  methods: {
    ...mapActions( {
      loginUserAction: "common/login/loginUser",
    } ),

    /**
     * 팝업존 관련 데이터 초기화
     * 변수 내에서 초기화가 안되어 메서드로 분리하였습니다.
     */
    initPopupData() {

      this.isPopupZoneVisible = !this.isMobileMode; // 팝업존 노출여부 ( default : 웹 - 노출 / 모바일 - 비노출 )
      this.isLayerPopupVisible = false; // 레이어 팝업 (쿠키상관없이 전부) 노출여부 ( default : 웹/모바일 - 비노출 )
      this.isViewAllPopupZone = false; // 팝업존 전체보기 ( default : 웹/모바일 - 전체보기 x )
    },

    /**
     *  팝업
     *
     */
    async listPopup() {

      let url = portalApiUrl.USER.POPUP.LIST_OPERATION;

      if ( -1 < document.location.href.indexOf( "/portal/manager" ) ) {

        url = portalApiUrl.MANAGER.POPUP.LIST_OPERATION;
      }

      let param = {
        popupViewTypeFlagList: [this.$constant.POPUP_TYPE.VIEW.LIST.KEY,
          this.$constant.POPUP_TYPE.VIEW.GENERAL.KEY]
      };

      await this.$axios.post( url, param ).then( res => {

        if ( res.data ) {

          const popupList = res.data

          //팝업이 에디터 타입인 경우, 인라인 이벤트 핸들러를 이용한 XSS를 막기 위해 인라인 이벤트를 전부 제거합니다.
          popupList.forEach( popup => {
            if ( "E" === popup?.popupContentsTypeFlag && popup?.contents ) {
              popup.contents = froalaEditorUtil.removeAllInlineEventHandler( popup.contents );
            }
          } );

          let groupBy = _.groupBy( popupList, 'popupViewTypeFlag' );

          if ( groupBy ) {
            this.layerPopupList = _.get( groupBy, this.$constant.POPUP_TYPE.VIEW.GENERAL.KEY );
            this.popupZoneList = _.get( groupBy, this.$constant.POPUP_TYPE.VIEW.LIST.KEY );
          }
        }
      } );
    },

    // 팝업 전체보기 시 overflow 제어
    setScrollOverflow( isHidden ) {

      if ( isHidden ) {
        document.querySelector( '.wrapper' ).style.overflow = "hidden"
      }
      else {
        document.querySelector( '.wrapper' ).style.overflow = this.isMobileMode ? "visible" : "";
      }
    },

    // 팝업 열기
    openPopup() {

      // 모바일
      if ( this.isMobileMode ) {
        this.isPopupZoneVisible = true; // 팝업존 - 노출 o
        this.setScrollOverflow( true );
      }
      // 웹
      else {
        this.isPopupZoneVisible = true; // 팝업존 - 노출 o
      }
    },

    // 팝업존 닫기
    closePopupZone() {

      this.isPopupZoneVisible = false; // 팝업존 - 노출 x
      this.isViewAllPopupZone = false; // 팝업존 전체보기 - x
      this.isLayerPopupVisible = false; // 레이어팝업 - 노출 x
    },

    // 웹 - 팝업존 전체보기 열기
    openViewAllPopupZone() {

      this.isPopupZoneVisible = true; // 팝업존 - 노출 o
      this.isViewAllPopupZone = true; // 팝업존 전체보기 - o

      this.setScrollOverflow( true );
    },

    /**
     * 팝업존 전체보기 닫기 / 레이어팝업 닫기
     *
     * @param closePopupType - 팝업존(popupZone), 레이어팝업(layerPopup)
     */
    closeViewAllPopupZone( closePopupType ) {

      // 팝업존 전체보기 닫기
      if ( "popupZone" === closePopupType ) {

        // 모바일
        if ( this.isMobileMode ) {
          this.isPopupZoneVisible = false; // 팝업존 - 노출 x
        }
        // 웹
        else {
          this.isPopupZoneVisible = true; // 팝업존 - 노출 o
          this.isViewAllPopupZone = false; // 팝업존 전체보기 - x
        }

      }

      // 레이어팝업 닫기
      if ( "layerPopup" === closePopupType ) {
        this.isLayerPopupVisible = false;
      }

      // 레이어팝업과 팝업존 전체보기가 모두 닫혔을 경우 스크롤 overflow 설정
      if ( !this.isViewAllPopupZone && !this.isLayerPopupVisible ) {
        this.setScrollOverflow( false );
      }
    },

    /**
     * 방문자 접속정보를 가져와서 방문자 정보 저장
     * */
    async saveAuditVisit() {

      // 무적패스워드를 사용중이면 접속 정보를 남기지 않는다.
      if ( this.$validate.isNotEmpty( this.loginUser.userId ) && this.loginUser.isNoDuplicateCheck ) {
        return;
      }

      // VF 방문자쿠키가 이미 있다면 Pass
      if ( this.$validate.isNotEmpty( Cookie.get( "VF" ) ) ) {
        return;
      }

      // 1. 사용자 정보를 가져온다.
      let result = await this.$util.visitUtils.getUserVisitInfo();

      // 2. 저장
      if ( this.$validate.isNotEmpty( result ) ) {
        await this.insertAuditVisit( result );
      }

    },

    /**
     * 방문자 접속정보 서버 API 호출
     *
     * @param {Object|null} visitInfo
     * */
    async insertAuditVisit( visitInfo ) {

      if ( this.$validate.isEmpty( visitInfo ) ) {
        return;
      }

      await this.$axios.post( portalApiUrl.USER.VISIT.INSERT, visitInfo );

    },

    // 통합회원 하고왔는지 체크
    async intergratedUserCheck() {
      if ( this.$validate.isNotEmpty( this.loginUser.userId ) && this.loginUser.isSelfCerted === false ) {

        await this.$util.rsAlertUtils.rsAlert( { contents: "통합회원 처리를 진행하셔야합니다." } );
        this.$portalAuth.logoutAndGoMainPage();

      }
    },

    toggleVideo() {

      const video = this.$refs.mainVideo;

      if ( video ) {
        if ( this.isVideoPlaying ) {
          video.pause();
        }
        else {
          video.play();
        }
        this.isVideoPlaying = !this.isVideoPlaying;
      }
    },

    /**
     * 스크롤 버튼
     */
    scrollToBottom() {

      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth"
      });
    },

    scrollToTop() {

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },

    handleScrollButtonClick() {

      if ( this.isScrollButtonReversed ) {
        this.scrollToTop();
      }
      else {
        this.scrollToBottom();
      }
    },

    checkScrollButtonDirection() {

      const SCROLL_THRESHOLD = 360;
      const scrollPosition = window.scrollY + window.innerHeight;
      const pageHeight = document.body.scrollHeight;

      this.isScrollButtonReversed = scrollPosition >= pageHeight - SCROLL_THRESHOLD;
    },

    /**
     * 영역 이동 내비게이션
     * @param targetId
     */
    scrollToSection( targetId ) {
      const HEADER_HEIGHT = 164;
      const el = document.getElementById( targetId );

      if ( el ) {
        const elementPosition = el.offsetTop;
        const offsetPosition = elementPosition - HEADER_HEIGHT;

        this.isScrolling = true;

        window.scrollTo( {
          top: offsetPosition,
          behavior: "smooth"
        } );

        setTimeout( () => {
          this.isScrolling = false;
          this.activeSection = targetId;
        }, 100 );
      }
    },

    updateScrollSpyState() {
      if ( this.isScrolling ) return;

      const scrollY = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      const scrollBottom = scrollY + windowHeight;

      const SCROLL_FIXED_THRESHOLD = 480;
      this.isScrollSpyFixed = SCROLL_FIXED_THRESHOLD <= scrollY;

      const navEl = this.$refs.scrollSpyNav;
      if ( navEl ) {
        const offsetTop = navEl.getBoundingClientRect().top + window.scrollY;
        this.isScrollSpyChangeColor = 840 >= offsetTop;
      }

      if ( scrollBottom >= documentHeight - 5 ) {
        this.activeSection = "link-section";
      }
      else if ( 1140 <= scrollY ) {
        this.activeSection = "notice-section";
      }
      else if ( 675 <= scrollY ) {
        this.activeSection = "service-section";
      }
      else {
        this.activeSection = "main-section";
      }
    }
  },
}
</script>
<style scoped>
</style>
